import { faEdit, faTrashCan } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Button, ButtonGroup, Chip, Container, Grid, IconButton, Typography } from "@mui/material"
import { hasRole } from "auth/hasRole"
import { useApiDelete } from "auth/useApi2"
import { useApi } from "auth/useApi3"
import { AppContext } from "components/AppContextProvider"
import ClpTable from "components/ClpTable"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { apiEndpoints } from "generated/apiEndpoints"
import { allRoles } from "generated/roles"
import { useContext, useEffect, useState } from "react"
import { StyledTableContainer } from "shared/styled/Global"
import { TechnicalPackageForm } from "./components/TechnicalPackageList/TechnicalPackageForm/TechnicalPackageForm"
import TableButton from "components/ClpTable/components/actions/TableButton/TableButton"
import { StyledTableButtonGroup } from "components/ClpTable/components/actions/TableButton/tableButtonGroup.styled"
import { TableButtonTypeEnum } from "components/ClpTable/components/actions/TableButton/tableButtonProps.interface"
import { useTranslation } from "react-i18next"

const ListTechincalPackage = () => {
  const { t } = useTranslation()
  const appContext = useContext(AppContext)
  const loadingContext = useContext(GlobalLoaderContext)
  const [technicalPackageResult, technicalPackageApi] = useApi()
  const [technicalPackageByIdResult, technicalPackageByIdApi] = useApi()
  const [addTechnicalPackageResult, addTechnicalPackageApi] = useApi()
  const [updateTechnicalPackageResult, updateTechnicalPackageApi] = useApi()
  const [deleteResult, deleteNotification] = useApiDelete()
  const [editMode, setEditMode] = useState(false)
  const [addOrUpdateResultState, setAddOrUpdateResultState] = useState(null)
  const [equipmentTypesResult, equipmenttypesApi] = useApi()

  useEffect(() => {
    technicalPackageApi.get(apiEndpoints.systemadmindeviceregistry.listtechnicalpackage)
    return () => {
      technicalPackageApi.leave()
    }
  }, [technicalPackageApi])

  useEffect(() => {
    equipmenttypesApi.get(apiEndpoints.systemadmindeviceregistry.gettechnicalpackageequipmenttype)
  }, [equipmenttypesApi])

  useEffect(() => {
    loadingContext.setLoading(() => technicalPackageResult.status === 1)
  }, [])

  const handleDelete = (id) => {
    deleteNotification(apiEndpoints.systemadmindeviceregistry.deletetechnicalpackage.replace("{id}", id))
  }

  const getFormData = (id) => {
    appContext.toggleSideBar(true)
    setAddOrUpdateResultState(null)
    if (id) {
      setEditMode(true)
      technicalPackageByIdApi.get(
        apiEndpoints.systemadmindeviceregistry.gettechnicalpackagebyid.replace("{id}", id)
      )
    } else {
      setEditMode(false)
    }
  }

  const onSubmit = (values) => {
    if (editMode) {
      updateTechnicalPackageApi.put(apiEndpoints.systemadmindeviceregistry.updatetechnicalpackage, values)
    } else {
      addTechnicalPackageApi.post(apiEndpoints.systemadmindeviceregistry.addtechnicalpackage, values)
    }
  }
  useEffect(() => {
    if (updateTechnicalPackageResult.status === 2) {
      technicalPackageApi.get(apiEndpoints.systemadmindeviceregistry.listtechnicalpackage)
      appContext.toggleSideBar(false)
      setEditMode(false)
    }
    setAddOrUpdateResultState(updateTechnicalPackageResult)
  }, [updateTechnicalPackageResult])

  useEffect(() => {
    if (addTechnicalPackageResult.status === 2) {
      technicalPackageApi.get(apiEndpoints.systemadmindeviceregistry.listtechnicalpackage)
      appContext.toggleSideBar(false)
      setEditMode(false)
    }
    setAddOrUpdateResultState(addTechnicalPackageResult)
  }, [addTechnicalPackageResult])

  useEffect(() => {
    if (deleteResult.status === 2) {
      technicalPackageApi.get(apiEndpoints.systemadmindeviceregistry.listtechnicalpackage)
    }
    setAddOrUpdateResultState(updateTechnicalPackageResult)
  }, [deleteResult])

  const columns = [
    {
      accessorKey: "name",
      header: t("global.name", "Name")
    },
    {
      accessorKey: "description",
      header: t("global.description", "Description")
    },
    {
      accessorKey: "equipmentTypes",
      header: t("global.equipment", "Equipment"),
      cell: ({ cell }) => {
        return cell.row.original.equipmentTypes.map((x) => {
          return <Chip sx={{ marginRight: 1.4 }} variant="outlined" label={x.name} size="small"></Chip>
        })
      }
    }
  ]

  if (hasRole(appContext.appUser, allRoles.SystemAdminDeviceRegistry)) {
    columns.push({
      cell: ({ cell }) => {
        return (
          <StyledTableButtonGroup>
            <TableButton
              type={TableButtonTypeEnum.Edit}
              handleOnClick={() => getFormData(cell.row.original.id)}
            />
            <TableButton
              type={TableButtonTypeEnum.Delete}
              handleOnClick={() => handleDelete(cell.row.original.id)}
            />
          </StyledTableButtonGroup>
        )
      },
      align: "right",
      accessorKey: "action",
      header: "",
      hiddenFilter: true
    })
  }

  return (
    <div>
      <Container>
        <TechnicalPackageForm
          technicalpackageData={technicalPackageByIdResult.status === 2 && technicalPackageByIdResult?.data}
          onSubmit={onSubmit}
          editMode={editMode}
          addOrUpdateResultState={addOrUpdateResultState}
          equipmentTypesResult={equipmentTypesResult}
        />
        <Box>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h1">{t("global.technology_package", "Technology package")}</Typography>

            {hasRole(appContext.appUser, allRoles.SystemAdminDeviceRegistry) && (
              <Box>
                <Button variant="contained" component={Button} onClick={() => getFormData()} color="primary">
                  {t("global.add", "Add")} {t("global.technology_package", "Technology package")}
                </Button>
              </Box>
            )}
          </Grid>
        </Box>
      </Container>
      <StyledTableContainer>
        <ClpTable
          rows={technicalPackageResult.status === 2 && technicalPackageResult.data}
          columns={columns}
          loadingState={technicalPackageResult.status}
        />
      </StyledTableContainer>
    </div>
  )
}
export default ListTechincalPackage
